import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'moment/locale/es';
import moment from 'moment';
import numeral from 'numeral';
import { setTwoToneColor } from '@ant-design/icons';
import { Provider } from 'react-redux';
import { store } from './store';
import './App.less';
import { ConfigProvider, theme } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import es_ES from 'antd/lib/locale/es_ES';
import { PostHogProvider } from 'posthog-js/react';
import env from './environment';

import { OpenFeatureProvider, OpenFeature } from '@openfeature/react-sdk';
import { FbProvider } from '@featbit/openfeature-provider-js-client';
moment.locale('es');

numeral.register('locale', 'es', {
	delimiters: {
		thousands: '.',
		decimal: ','
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't'
	},
	ordinalIgnore: function (number) {
		return number === 1 ? 'er' : 'ème';
	},
	currency: {
		symbol: '€'
	}
});

numeral.locale('es');

setTwoToneColor('#5cb889');

const options = {
	api_host: 'https://eu.i.posthog.com'
};

window.addEventListener('error', (e) => {
	if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
		const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
		const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
		if (resizeObserverErr) {
			resizeObserverErr.setAttribute('style', 'display: none');
		}
		if (resizeObserverErrDiv) {
			resizeObserverErrDiv.setAttribute('style', 'display: none');
		}
	}
});

const renderKey = () => {
	if (env.env === 'dev') {
		return 'Gk2lTElfiUCx6JoZppiY5wdN7-6faJ6EiFhuqROo1o4w';
	} else if (env.env === 'prod') {
		return 'BL5TqHYRH0W8kZsocw5luwuavHBV5F80aM_01rZoQuiA';
	} else {
		return '2FJwNGRnHEi0onAqE5I9vQa3yLDBYAZ06sGPKSEFkvnA';
	}
};
const option = {
	sdkKey: renderKey(),
	streamingUri: 'wss://tiresias-evaluation.allbanks.es',
	eventsUri: 'https://tiresias-evaluation.allbanks.es',
	offline: true,
	user: {
		keyId: 'anonymous', // 👈 identificador único obligatorio
		name: 'anonymous', // opcional,
		managementCode: 'gibobs'
	}
};

const provider = new FbProvider(option);
await OpenFeature.setProviderAndWait(provider);
const client = OpenFeature.getClient();

ReactDOM.render(
	<PostHogProvider apiKey="phc_wCPqoKRGKNNCy2WcLWT0bxOfodcN0u1nLb3xMtVhqDS" options={options}>
		<Provider store={store}>
			<ConfigProvider
				locale={es_ES}
				theme={{
					algorithm: theme.defaultAlgorithm,
					token: { colorPrimary: '#02C3CD', colorBgLayout: '#FAFEFE' }
				}}>
				<BrowserRouter>
					<OpenFeatureProvider client={client}>
						<App />
					</OpenFeatureProvider>
				</BrowserRouter>
			</ConfigProvider>
		</Provider>
	</PostHogProvider>,

	document.getElementById('root')
);

serviceWorker.unregister();
